import * as React from "react";

function MiningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.265 3.703c-2.536-.225-4.88.459-6.423 1.79-.19.164-.02.443.226.385 1.717-.41 3.67-.494 5.704-.197l.493-1.978zM15.168 6.527c1.935.693 3.62 1.685 4.944 2.853.189.166.472 0 .38-.235-.736-1.899-2.486-3.603-4.83-4.595l-.494 1.977zM12.481 5.936l1.94.484-1.209 4.851-1.94-.484zM10.787 10.667l2.91.726L11.4 20.61l-2.911-.726z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.358 3.329l3.396.847-.665 2.668-3.396-.847z"
  }));
}

export default MiningIcon;